import styled from '@emotion/styled';

export const PaginationContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 3.2rem;
	width: 100%;

	.pagination {
		display: flex;
		justify-content: center;

		li {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 3.5rem;
			height: 3.8rem;
			min-width: 2.8rem;
			font-size: ${(props) => props.theme.fontSize.sizeSm};
			font-weight: ${(props) => props.theme.fontWeight.weightRegular};
			cursor: pointer;
			transition: all 0.2s ease;
			border: 1px solid #dedfe7;
			border-right: none;

			a {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 100%;
				color: #adb5bd;
			}

			&.active {
				/* color: blue; */
				a {
					color: #212529;
				}
			}

			&:last-of-type {
				border-radius: 0 0.4rem 0.4rem 0;
				border-right: 1px solid #dedfe7;
			}

			&:first-of-type {
				border-radius: 0.4rem 0 0 0.4rem;
			}

			/* 커스텀 화살표 버튼 스타일 */
			&.first-page-btn,
			&.last-page-btn,
			&.prev-page-btn,
			&.next-page-btn {
				background-color: #f8f8f8;

				&:hover {
					background-color: #eaeaea;
				}
			}

			/* 비활성화 상태의 버튼 스타일 */
			&.disabled {
				cursor: not-allowed;
				&:hover {
					background-color: transparent;
				}
			}
		}
	}
`;
